module.exports = __webpack_public_path__ + "static/media/logo_black.db799694.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_black.svg
// module id = 375
// module chunks = 21